import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import logo from "../images/logo-bageri.svg"
import arrow from "../images/arrow-2.svg"
import axios from 'axios';


const Header = ({ siteTitle }) => (
  <header className="section headerSection" >
    <div className="container headerContainer">
      <div className="columns headerImage">
        <div className="column backButtonColumn"> 

        <a id="clickButton2" class="button2" href="https://www.bageriapril.se/" target="_PARENT">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14">
            <path fill="#FFF" d="M6.7 13.4L8.1 12 3.8 7.7 16 7.7 16 5.7 3.8 5.7 8.1 1.4 6.7 0 0 6.7z"/>
        </svg>
        <span>Tillbaka</span> 

    </a>
        </div>
        <div className="column logoColumn">
          <figure>
            <img src={logo} className="headerLogoImage"></img>
          </figure>
        </div>
        <div className="column emptyColumn"></div>
      </div>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
